module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("I am eternally grateful to all the people who have encouraged me in one way or the next; literally, too numerous to mention, but you know yourselves so take a bow. To all the people who have inspired me; keep on shining, sometimes the rest of us need your light to find our way. Thank you, Marva Waugh, John “Toby” Cadham, Saundra Fisher, Gail Bogle, Nadia Nembhard-Hunt, Courace Fisher and Barbara Stewart-Edwards for your constant and consistent encouragement you are appreciated.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0